module.exports = __webpack_public_path__ + "static/media/logo-appluss.4a6d6e4b.png";